import React, { useState, useEffect } from "react";
import { useNavigate, useLocation, Link } from "react-router-dom";
import ApiServices from "../../api/ApiServices";
import { toast } from "react-toastify";
import MainLayouts from "../../Layout/MainLayouts";
import { ReactComponent as ChevronRightIcon } from "bootstrap-icons/icons/chevron-right.svg";
import { handleError } from "../../components/utils/AuthenticationCheck";
import AxiosApiCall from "../../api/AxiosApiCall";

const CustomerStatus = () => {
    const [firstname, setFirstName] = useState("");
    const [lastname, setLastName] = useState("");
    const [email, setEmail] = useState("");
    const [id, setId] = useState("");
    const [status, setStatus] = useState("");
    const navigate = useNavigate();
    const [loading, setLoading] = useState(false);

    const location = useLocation();
    const data = location.state || {};

    useEffect(() => {
        if (data) {
            // console.log("data", data);
            setId(data.data.id || "");
            setEmail(data.data.email || "");
            setFirstName(data.data.firstname || "");
            setLastName(data.data.lastname || "");
            // setStatus(data.data.status || "");
            setStatus(data.data.status?.toLowerCase() || "");
        }
    }, [data]);

    //axios api encryption call
    const axios = AxiosApiCall();

    const handleSubmit = async (e) => {
        e.preventDefault();

        const validateForm = () => {
            if (!status) {
                toast.error("Select a  status.");
                return false;
            }
            return true;
        };

        if (!validateForm()) return;

        const authData = JSON.parse(localStorage.getItem("auth"));
        const adminToken = authData?.token;

        setLoading(true);
        const formData = {
            status,
            user_id: id
        };
        //  console.log(formData);
        try {
            const token = adminToken;
            if (!token) {
                throw new Error("No access token found.");
            }

            const response = await axios.put(ApiServices.getCustomerStatus, formData, {
                headers: {
                    Authorization: `Bearer ${token}`,
                    "Content-Type": "application/json",
                },
                withCredentials: true,
            });

            const { status, message } = response.data;
            if (status === 200) {
                setStatus("");
                navigate("/admin/customer");
                toast.success(message);
            } else {
                handleError({ response: { status, data: { message } } }, navigate);
            }
        } catch (error) {
            handleError(error, navigate);
        } finally {
            setLoading(false);
        }
    };



    return (
        <div>
            <MainLayouts>
                <div className="relative overflow-x-auto sm:rounded-lg py-6 w-full">
                    <section
                        className="w-full pr-[3%] pt-3 my-3"
                        style={{ backgroundColor: "#F7F7F7" }}
                    >
                        <nav className="bg-gray-200 py-0 px-4 rounded-lg">
                            <ol className="list-none p-0 inline-flex mb-2">
                                <li className="flex items-center">
                                    <p className="text-blue-500 hover:text-blue-600 text-darkGreen3 pr-2">
                                        Customer
                                    </p>
                                    <ChevronRightIcon />
                                </li>
                                <li className="flex items-center">
                                    <p className="text-orange1">
                                        status
                                    </p>
                                </li>
                            </ol>
                        </nav>
                    </section>

                    <section className="gray_background">
                        <div className="mx-auto">
                            <div className="lg:w-full md:w-full bg-white rounded-lg p-8 flex flex-col md:ml-auto w-full mt-10 md:mt-0 relative z-10 shadow-md bg-dGrey3">
                                <form onSubmit={handleSubmit}>
                                    <div className="mb-5">
                                        <label
                                            htmlFor="fullname"
                                            className="block mb-2 text-sm font-medium text-gray-900 dark:text-white"
                                        >
                                            Customer Full Name
                                        </label>
                                        <input
                                            type="text"
                                            id="fullname"
                                            value={`${firstname} ${lastname}`}
                                            readOnly
                                            className="pr-12 pl-4 shadow-sm bg-dGrey1 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500 dark:shadow-sm-light"
                                        />
                                    </div>

                                    <div className="mb-5">
                                        <label
                                            htmlFor="email"
                                            className="block mb-2 text-sm font-medium text-gray-900 dark:text-white"
                                        >
                                            Admin email
                                        </label>
                                        <div className="w-full">
                                            <input
                                                type="text"
                                                id="email"
                                                value={email}
                                                readOnly
                                                className="pr-12 pl-4 shadow-sm bg-dGrey1 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500 dark:shadow-sm-light"
                                            />
                                        </div>
                                    </div>
                                    <div className="w-full mb-4">
                                        <label
                                            htmlFor="status"
                                            className="block mb-2 text-sm font-medium text-gray-900 dark:text-white"
                                        >
                                            Status
                                        </label>
                                        <select
                                            id="status"
                                            value={status}
                                            onChange={(e) => setStatus(e.target.value)}
                                            className="bg-gray-50 border border-dGrey1 text-gray-900 text-sm rounded-lg focus:ring-primary-500 focus:border-primary-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-primary-500 dark:focus:border-primary-500"
                                        >
                                            <option value="" disabled>
                                                Select status
                                            </option>
                                            <option value="active">Active</option>
                                            <option value="blocked">Blocked</option>
                                            <option value="deleted">Deleted</option>
                                        </select>
                                    </div>


                                    <div className="flex justify-end gap-4 mt-4">
                                        <button
                                            type="submit"
                                            className={`text-white bg-darkGreen3  text-lGrey py-2 px-6 rounded font-medium w-48 ${loading ? "opacity-50 cursor-not-allowed" : "hover:bg-indigo-600"}`}
                                            disabled={loading}
                                        >
                                            {loading ? "Loading..." : "Update Status"}
                                        </button>

                                        <Link
                                            to="/admin/customer"
                                            className="text-white bg-black2 py-2 px-6 text-lGrey rounded font-medium w-48 hover:bg-indigo-600 text-center flex items-center justify-center"
                                        >
                                            Go Back
                                        </Link>
                                    </div>


                                </form>
                            </div>
                        </div>
                    </section>
                </div>
            </MainLayouts>
        </div>
    );
};

export default CustomerStatus;
